import React from "react";
import { bool } from "prop-types";
import { classes } from "../utils/classes";
import Dropdown from "../Dropdown";
import NavbarItem from "../Navbar/Item";

const DropdownUlItem = ({ ...props }) => <Dropdown Tag="li" {...props} />;

const NavbarDropdown = ({
	isMegaMenu = false,
	isSecondaryNav = false,
	className = "",
	children,
	...props
}) => {
	return (
		<NavbarItem
			Tag={DropdownUlItem}
			secondary={isSecondaryNav}
			isMegaMenu={isMegaMenu}
			className={classes(className)}
			{...props}
		>
			{children}
		</NavbarItem>
	);
};

NavbarDropdown.propTypes = {
	isMegaMenu: bool,
	isSecondaryNav: bool,
	...Dropdown.propTypes,
};

export default NavbarDropdown;
